<div class="row">
  <div class="col-12">
    <div class="container-fluid container-1600">
      <div class="contact-map">
        <div class="mapouter">
          <div class="gmap_canvas">
            <iframe
              id="gmap_canvas"
              src="https://maps.google.com/maps?q=colegio%20de%20arquitectos%20tabas&t=&z=13&ie=UTF8&iwloc=&output=embed"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
            >
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
